import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=2cf20b08&scoped=true"
import script from "./editGroup.vue?vue&type=script&lang=js"
export * from "./editGroup.vue?vue&type=script&lang=js"
import style0 from "./editGroup.vue?vue&type=style&index=0&id=2cf20b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf20b08",
  null
  
)

export default component.exports